export default "__VITE_ASSET__CxoQzTVn__"